/* ==========================================================================
   CL - Navbar Glass (Version Oscura) - comportamiento
   - Sticky con clase .is-stuck al hacer scroll
   - Drawer movil (abrir/cerrar, Esc, backdrop, scroll-lock)
   - Busqueda: abre el modal propio (compatible con Searchanise);
     en mobile sin la app, navega a /search
   - Carrito movil: abre el cart-drawer del tema y espeja el contador
     desde #cart-icon-bubble (barra desktop) con un MutationObserver
   - Mega menus: ancla cada panel a su categoria y cierra al hacer
     clic fuera. Inyecta cart.js/cart-drawer.js si el header
     original del tema esta oculto.
   ========================================================================== */

(function () {
	'use strict';

	function initNavGlass(nav) {
		if (!nav || nav.dataset.clInit === 'true') return;
		nav.dataset.clInit = 'true';

		/* ---------- Sticky ----------
		   Histeresis: se pega pasando stickAt y se despega hasta bajar
		   de unstickAt. Con un solo umbral, el estado parpadeaba justo
		   en el corte (sobre todo en mobile, donde la barra del
		   navegador cambia el scroll) y la animacion de entrada se
		   re-disparaba una y otra vez - la barra "tambaleaba" y pasaba
		   ratos fuera de pantalla. El rAF garantiza evaluar SIEMPRE el
		   ultimo scroll (el throttle de tiempo se tragaba el final). */
		if (nav.dataset.sticky === 'true') {
			var stickAt = 80;
			var unstickAt = 24;
			var ticking = false;

			var applyState = function () {
				var y = window.scrollY;
				if (y > stickAt) {
					nav.classList.add('is-stuck');
				} else if (y < unstickAt) {
					nav.classList.remove('is-stuck');
				}
				/* entre ambos umbrales se conserva el estado */
			};

			var onScroll = function () {
				if (ticking) return;
				ticking = true;
				window.requestAnimationFrame(function () {
					ticking = false;
					applyState();
				});
			};

			/* Alto de la barra visible -> padding que evita el brinco de
			   layout cuando pasa a fixed en paginas sin modo overlay */
			var updateStuckPad = function () {
				var isMobile = window.matchMedia('(max-width: 999px)').matches;
				var bar = nav.querySelector(
					isMobile ? '.cl-navglass__bar--mobile' : '.cl-navglass__bar'
				);
				if (bar) {
					nav.style.setProperty('--cl-nav-stuck-pad', bar.offsetHeight + 'px');
				}
			};

			window.addEventListener('scroll', onScroll, { passive: true });
			var padTimer;
			window.addEventListener(
				'resize',
				function () {
					window.clearTimeout(padTimer);
					padTimer = window.setTimeout(updateStuckPad, 150);
				},
				{ passive: true }
			);
			updateStuckPad();
			applyState();
		}

		/* ---------- Drawer movil ---------- */
		var drawer = nav.querySelector('[data-cl-drawer]');
		var openBtn = nav.querySelector('[data-cl-drawer-open]');
		var lastFocused = null;

		function openDrawer() {
			if (!drawer) return;
			lastFocused = document.activeElement;
			drawer.removeAttribute('hidden');
			document.body.classList.add('cl-navglass-drawer-open');
			var closeBtn = drawer.querySelector('[data-cl-drawer-close]');
			if (closeBtn) closeBtn.focus();
			if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
		}

		function closeDrawer() {
			if (!drawer) return;
			drawer.setAttribute('hidden', '');
			document.body.classList.remove('cl-navglass-drawer-open');
			if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
			if (lastFocused) lastFocused.focus();
		}

		if (openBtn) openBtn.addEventListener('click', openDrawer);

		if (drawer) {
			drawer.addEventListener('click', function (event) {
				if (
					event.target.closest('[data-cl-drawer-close]') ||
					event.target.matches('[data-cl-drawer-backdrop]')
				) {
					closeDrawer();
				}
			});

			document.addEventListener('keydown', function (event) {
				if (event.key === 'Escape' && !drawer.hasAttribute('hidden')) {
					closeDrawer();
				}
			});
		}

		/* ---------- Busqueda: modal propio compatible con Searchanise ----------
		   El boton lleva la clase search-open-btn (searchanise-theme-cards.js
		   engancha el clic para auto-abrir su panel) y este handler muestra
		   el contenedor .header__search-inner y enfoca el input[name="q"],
		   que es donde el widget de la app se ata. */
		var searchModal = nav.querySelector('[data-cl-search-modal]');

		function openSearch() {
			searchModal.classList.add('header__search-inner--open');
			document.body.classList.remove('cl-isearch-focus');
			var input = searchModal.querySelector('input[name="q"]');
			/* El focus va SINCRONO, dentro del mismo toque: iOS y Android solo
			   abren el teclado si el focus() ocurre en el gesto del usuario
			   (con el setTimeout anterior el cursor aparecia pero el teclado
			   no). Searchanise luego pasa el foco a su propio input y el
			   teclado se mantiene abierto. */
			if (input) {
				try {
					input.focus({ preventScroll: true });
				} catch (e) {
					input.focus();
				}
			}
		}

		function closeSearch() {
			searchModal.classList.remove('header__search-inner--open');
		}

		nav.querySelectorAll('[data-cl-search]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				/* En mobile el modal propio va fuera de pantalla y solo se usa
				   el overlay de Searchanise; si la app no esta presente, se
				   navega a la pagina de busqueda para no dejar al usuario
				   sin respuesta. */
				var isMobile = window.matchMedia('(max-width: 999px)').matches;
				var appPresent = document.querySelector('[class*="snize"]') || window.Searchanise;
				if (isMobile && !appPresent) {
					window.location.href = btn.dataset.searchUrl || '/search';
					return;
				}
				if (searchModal) {
					openSearch();
					return;
				}
				window.location.href = btn.dataset.searchUrl || '/search';
			});
		});

		if (searchModal) {
			searchModal.addEventListener('click', function (event) {
				if (event.target.closest('[data-cl-search-close]')) closeSearch();
			});

			document.addEventListener('keydown', function (event) {
				if (
					event.key === 'Escape' &&
					searchModal.classList.contains('header__search-inner--open')
				) {
					closeSearch();
				}
			});

			document.addEventListener('click', function (event) {
				if (!searchModal.classList.contains('header__search-inner--open')) return;
				if (searchModal.contains(event.target)) return;
				if (event.target.closest('[data-cl-search]')) return;
				/* No cerrar al interactuar con el panel de Searchanise */
				if (event.target.closest('[class*="snize"]')) return;
				closeSearch();
			});
		}

		/* ---------- Buscador abierto (desktop) ----------
		   El input vive dentro de la pildora. Searchanise cuelga su panel
		   de sugerencias del input; con la clase cl-isearch-focus el CSS lo
		   alinea al borde derecho del buscador (si no, se desborda). */
		var inlineSearch = nav.querySelector('[data-cl-isearch]');
		if (inlineSearch) {
			var inlineInput = inlineSearch.querySelector('input[name="q"]');
			var placePanel = function () {
				var r = inlineInput.getBoundingClientRect();
				var right = Math.max(16, Math.round(document.documentElement.clientWidth - r.right));
				document.documentElement.style.setProperty('--cl-isearch-right', right + 'px');
			};
			if (inlineInput) {
				inlineInput.addEventListener('focus', function () {
					placePanel();
					document.body.classList.add('cl-isearch-focus');
				});
				window.addEventListener(
					'resize',
					function () {
						if (document.body.classList.contains('cl-isearch-focus')) placePanel();
					},
					{ passive: true }
				);
			}
		}

		/* ---------- Carrito movil ----------
		   Abre el cart-drawer del tema pasando el boton como triggeredBy
		   (cl-cart-toast.js suprime los open() sin origen). Si el drawer
		   no esta disponible (cart_type "page", la propia pagina del
		   carrito o el custom element aun sin definir), el enlace navega
		   a /cart con normalidad. */
		var cartBtnM = nav.querySelector('[data-cl-cart-m]');
		if (cartBtnM) {
			cartBtnM.addEventListener('click', function (event) {
				var cartDrawer = document.querySelector('cart-drawer');
				if (cartDrawer && typeof cartDrawer.open === 'function') {
					event.preventDefault();
					cartDrawer.open(cartBtnM);
				}
			});

			/* Contador: cart.js / cart-drawer.js solo reemplazan el
			   innerHTML de #cart-icon-bubble (barra desktop, oculta en
			   mobile pero presente en el DOM); la burbuja movil se espeja
			   desde ahi con un MutationObserver. El nodo observado nunca
			   se reemplaza, solo su contenido. */
			var bubbleM = cartBtnM.querySelector('[data-cl-cart-m-count]');
			var desktopBubble = nav.querySelector('#cart-icon-bubble');

			if (bubbleM && desktopBubble) {
				var syncCartCount = function () {
					var count = desktopBubble.querySelector('.cart-count-bubble span[aria-hidden]');
					if (count) {
						bubbleM.textContent = count.textContent.trim();
						bubbleM.removeAttribute('hidden');
					} else {
						bubbleM.textContent = '';
						bubbleM.setAttribute('hidden', '');
					}
				};

				new MutationObserver(syncCartCount).observe(desktopBubble, {
					childList: true,
					subtree: true
				});
				syncCartCount();
			}
		}

		/* ---------- Assets del cart-drawer ----------
		   El header original de Force es quien carga cart.js y
		   cart-drawer.js. Si esta oculto, se inyectan aqui (en orden:
		   cart.js define CartItems, del que hereda CartDrawerItems).
		   Se ejecuta tras DOMContentLoaded para que los scripts defer
		   del header (si existe) ya se hayan registrado. */
		function ensureCartAssets() {
			if (window.customElements.get('cart-drawer')) return;
			var cartJs = nav.dataset.cartJs;
			var cartDrawerJs = nav.dataset.cartDrawerJs;
			if (!cartJs || !cartDrawerJs) return;
			if (document.querySelector('script[src="' + cartDrawerJs + '"]')) return;
			var s1 = document.createElement('script');
			s1.src = cartJs;
			s1.onload = function () {
				var s2 = document.createElement('script');
				s2.src = cartDrawerJs;
				document.body.appendChild(s2);
			};
			document.body.appendChild(s1);
		}

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', ensureCartAssets);
		} else {
			ensureCartAssets();
		}

		/* ---------- Ancla cada mega menu a su categoria ----------
		   El panel nace alineado al item abierto, sin salirse de la
		   pildora del menu (se recorre a la izquierda si no cabe). */
		nav.querySelectorAll('.cl-navglass__dd details').forEach(function (details) {
			details.addEventListener('toggle', function () {
				if (!details.open) return;
				var mega = details.querySelector('.cl-navglass__mega');
				var menuPill = details.closest('.cl-navglass__menu');
				var summary = details.querySelector('summary');
				if (!mega || !menuPill || !summary) return;
				/* Con la pildora unica el panel se posiciona respecto a
				   .cl-navglass__group (menu + buscador), asi puede extenderse
				   por debajo del buscador sin salirse de la pildora. */
				var host = details.closest('.cl-navglass__group') || menuPill;
				mega.style.left = '0px';
				var itemLeft = summary.getBoundingClientRect().left - host.getBoundingClientRect().left;
				var maxLeft = host.offsetWidth - mega.offsetWidth;
				var left = Math.min(itemLeft, maxLeft);
				if (left < 0) left = 0;
				mega.style.left = (left - 1) + 'px';
			});
		});

		/* ---------- Cierra los mega menus al hacer clic fuera ---------- */
		document.addEventListener('click', function (event) {
			nav
				.querySelectorAll('.cl-navglass__dd details[open]')
				.forEach(function (details) {
					if (!details.contains(event.target)) {
						details.removeAttribute('open');
					}
				});
		});
	}

	function initAll() {
		document.querySelectorAll('.cl-navglass').forEach(initNavGlass);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', initAll);
})();
